import React from 'react';
import './classes/ConferenceFooter.css';

// The live site's "Want to be involved in this event?" banner, across the page between the content
// and the footer of every conference page (#conference_footer in the live theme's footer block).
// Live types the text twice, for desktop and phones, with the same words; it is shown once here.
const ConferenceFooter = () => (
    <div id="conference_footer">
        <div className="conference-footer-body">
            <div className="conference-footer-heading">Want to be involved in this event?</div>
            <div className="conference-footer-text">
                For information on sponsorship opportunities, <br />
                please contact <span className="conference-footer-email"><a href="mailto:info@smww.com">Info@SMWW.com</a></span>
            </div>
        </div>
    </div>
);

export default ConferenceFooter;
